const isJsonString = (str: any) => {
  try {
    if (typeof str !== 'string') return false;

    JSON.parse(str);
  } catch {
    return false;
  }

  return true;
};

export default isJsonString;
